import React, { useState } from 'react';
import { FaAndroid, FaBoxOpen, FaDesktop, FaGlobe, FaMobileAlt, FaShoppingCart, FaUserTie } from 'react-icons/fa';
import AddProducts from '../../../assets/Docs/Add_Products.png'
import product_preview from '../../../assets/Docs/product_preview (3).png'
import { TagComponent } from '../Tabs';

const Products = () => {

  const [activeTab1, setActiveTab1] = useState('web');
  const [activeTab2, setActiveTab2] = useState('web');

  const tabs = [
    { id: 'web', label: 'Web App', icon: <FaDesktop /> },
    { id: 'mobile', label: 'Mobile App', icon: <FaMobileAlt />, disabled: true },
  ];

  const renderTabs = (activeState, setActiveState) => (
    <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => !tab.disabled && setActiveState(tab.id)}
          className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
            ? "bg-[#1a9588] text-white shadow"
            : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
            } ${tab.disabled ? "opacity-50 cursor-not-allowed hover:bg-[#dbf4f1]" : ""}`}
          disabled={tab.disabled}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );

  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">

      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <FaBoxOpen className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Products</h1>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="green" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="pink" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>




      <p className="text-start mb-6 text-gray-600 ">
        Products form the core of your catalogue & Selzor provides you with convenient ways to add & update them. You can insert multiple products in one go by using our data import feature. Once the products have been added, you can also update them easily.
      </p>
      <div className="text-start">
        <h3 className="text-2xl text-gray-500 font-semibold mb-2">Adding / Updating Products</h3>
        <p className="text-gray-400 mb-6">
          Go to the 'Products' section & click on 'Add New'. Fill in the fields and click 'Save'. The new product is saved to the database.
        </p>
      </div>
      {renderTabs(activeTab1, setActiveTab1)}
      <div className="rounded-lg p-2 sm:p-4 flex justify-start">
        <img
          src={AddProducts}
          alt={`${activeTab1} view`}
          className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
        />
      </div>
      <div className=' my-5'>
        <div className="text-start">
          <h3 className="text-2xl text-gray-500 font-semibold mb-2">Preview Products</h3>
          <p className="text-gray-400 mb-6">
            The product data entered can be viewed by double-clicking the product in the list. You can also save the product data as a PDF with just one click. Selzor provides you with complete flexibility to define which field should be included in the product PDF.
          </p>
        </div>
        {renderTabs(activeTab2, setActiveTab2)}
        <div className="rounded-lg p-2 sm:p-4 flex justify-start">
          <img
            src={product_preview}
            alt={`${activeTab2} view`}
            className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default Products;